import { render, staticRenderFns } from "./ModalSugestaoDeProtocolo.vue?vue&type=template&id=6d22e4ab&scoped=true"
import script from "./ModalSugestaoDeProtocolo.vue?vue&type=script&lang=ts"
export * from "./ModalSugestaoDeProtocolo.vue?vue&type=script&lang=ts"
import style0 from "./ModalSugestaoDeProtocolo.vue?vue&type=style&index=0&id=6d22e4ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22e4ab",
  null
  
)

export default component.exports